export default __webpack_public_path__ + "static/media/248.6c79e76a.jpg";